/* eslint-disable max-len */
import React from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Input, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import DatePicker from 'react-datepicker';
import {dateFormatPicker, reverseShortDate} from '../../../common/constants/datesFormat';
import moment from 'moment';
import '../styles/styles.scss';
import {sumShipment} from '../utils';

const ShipmentHeader = (props) => {
  const {shipmentHeader, setShipmentHeader} = props;

  const setHeaderValuesHandler = (name, value) => {
    setShipmentHeader(name, value);
  };
  const sumData = sumShipment(props.ordersByShipmentMapped, shipmentHeader.shipment);
  const sumNL = sumData.sumNL;
  const sumDP = sumData.sumDP;
  const sumFL = sumData.sumFL;
  const sumDN = sumData.sumDN;
  const sumDE = sumData.sumDE;

  const sumCurrentShipment = sumData.sum;

  return (
    <Card raised fluid className='small-container'>
      {props.loadingSecondary ?
        <Loader active inline='centered' className='custom-loader' /> :
        <div className='title-bar'>
          <Grid textAlign='left'>
            <Grid.Column width={16} className='distibute-horizontal'>
              <h4>DATOS DEL EMBARQUE</h4>
              
            </Grid.Column>
          </Grid>
          <Grid columns={2} divided className='no-space' textAlign='left'>
            <Grid.Row className='header-lines'>
              <Grid.Column className='header-lines'>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <h4>Embarque</h4>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h5>{shipmentHeader.shipment}</h5>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h4>Pedido</h4>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <h4>{shipmentHeader.orderNumber}</h4>
                    </Grid.Column>
                    {props.updateShipmentHeader === 'UPDATE' ? (
                      <>
                        <Grid.Column width={2}>
                          <h4>C&&F</h4>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <h5>$ {shipmentHeader.cif}</h5>
                        </Grid.Column>
                      </>
                    ) :
                      (
                        <Grid.Column width={4}>
                        </Grid.Column>
                      )
                    }
                    <Grid.Column width={3} className='header-top-space'>
                      <h4>Normal</h4>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h5>{sumNL}</h5>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <h4>Depósito</h4>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h5>{sumDP}</h5>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <h4>Flotante</h4>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <h5>{sumFL}</h5>
                    </Grid.Column>

                    <Grid.Column width={3} className='header-top-space'>
                      <h4>Diplomático nacional</h4>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h5>{sumDN}</h5>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <h4>Diplomático extranjero</h4>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h5>{sumDE}</h5>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <h4>Total de unidades</h4>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h5>{sumCurrentShipment}</h5>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <h4>Fecha de embarque</h4>
                    </Grid.Column>
                    <Grid.Column width={11}>
                      <DatePicker
                        placeholderText='Seleccione la fecha'
                        className='tcc-datepicker header-input custom-input-small'
                        showYearDropdown
                        selected={shipmentHeader.dateOfShipment ?
                          moment(shipmentHeader.dateOfShipment, reverseShortDate).toDate() :
                          null
                        }
                        dateFormat={dateFormatPicker}
                        customInput={<Input readOnly icon='calendar' size='small' />}
                        onChange={(value) => setHeaderValuesHandler('dateOfShipment', moment(value).format(reverseShortDate))}
                        locale='es'
                      />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <h4>Fecha de arribo</h4>
                    </Grid.Column>
                    <Grid.Column width={11}>
                      <DatePicker
                        placeholderText='Seleccione la fecha'
                        className='tcc-datepicker header-input custom-input-small'
                        showYearDropdown
                        selected={shipmentHeader.dateOfArrival ?
                          moment(shipmentHeader.dateOfArrival, reverseShortDate).toDate() :
                          null
                        }
                        dateFormat={dateFormatPicker}
                        customInput={<Input readOnly icon='calendar' size='small' />}
                        onChange={(value) => setHeaderValuesHandler('dateOfArrival', moment(value).format(reverseShortDate))}
                        locale='es'
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      }
    </Card>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    'loadingSecondary': state.manageOrders.loadingSecondary,
    'loading': state.manageOrders.loading,
    'listOrigins': state.manageOrders.listOrigins,
    'listProviders': state.manageOrders.listProviders,
    'originsAllData': state.manageOrders.originsAllData,
    'shipmentHeader': state.manageOrders.shipmentHeader,
    'updateShipmentHeader': state.manageOrders.updateShipmentHeader,
    'ordersByShipmentMapped': state.manageOrders.ordersByShipmentMapped,
  };
};
const {
  fetchPostShipmentHeader,
  setHeaderValues,
  setShowShipmentHeader,
  setShipmentHeader,
  setCleanShipmentHeader,
  setUpdateShipmentHeader,
} = Actions;

export default connect(mapStateToProps, {
  fetchPostShipmentHeader,
  setHeaderValues,
  setShowShipmentHeader,
  setShipmentHeader,
  setCleanShipmentHeader,
  setUpdateShipmentHeader,
})(ShipmentHeader);
